import { FormControl, FormGroup } from '@angular/forms';
import { CLPApplianceDetailsPersonDetailsForm } from '../clp/clp-appliance-details-person-details-form.interface';
import { ApplianceDetailsSteppedFormField } from './appliance-details-stepped-form-field.enum';

export interface ApplianceDetailsSteppedForm {
  [ApplianceDetailsSteppedFormField.ApplianceCategoryCode]: FormControl<
    string | null
  >;
  [ApplianceDetailsSteppedFormField.ApplianceCode]: FormControl<string | null>;
  [ApplianceDetailsSteppedFormField.ApplianceCodeBuiltIn]: FormControl<
    boolean | null
  >;
  [ApplianceDetailsSteppedFormField.BrandCode]: FormControl<string | null>;
  [ApplianceDetailsSteppedFormField.Person]: FormGroup<CLPApplianceDetailsPersonDetailsForm>;
  [ApplianceDetailsSteppedFormField.ModelAndSerialNumber]: FormGroup<{
    modelNumber: FormControl<string | null>;
    serialNumber: FormControl<string | null>;
  }>;
  [ApplianceDetailsSteppedFormField.PartsWarranty]: FormControl<number | null>;
  [ApplianceDetailsSteppedFormField.PurchaseDate]: FormControl<Date | null>;
  [ApplianceDetailsSteppedFormField.PurchasePrice]: FormControl<number | null>;
  [ApplianceDetailsSteppedFormField.Retailer]: FormControl<string | null>;
  [ApplianceDetailsSteppedFormField.Warranty]: FormControl<number | null>;
}
